module.exports = __webpack_public_path__ + "img/linkedin.d5bd0977.svg";